export default{
    install(Vue, options){
        Vue.prototype.filterArr = (search, arr)=>{
            if (search) {
                return arr.filter(data => {
                    return Object.keys(data).some(key => {
                        if (data[key] instanceof Object) {
                            return Object.keys(data[key]).some(dataKey => {
                                return (
                                    String(data[key][dataKey])
                                        .toLowerCase()
                                        .indexOf(search.toLowerCase()) > -1
                                );
                            });
                        } else {
                            return (
                                String(data[key])
                                    .toLowerCase()
                                    .indexOf(search.toLowerCase()) > -1
                            );
                        }
                    });
                });
            }
            return arr
        }
    }
}